<template>
  <b-input-group>
    <b-form-input
      :value="value"
      v-bind="$attrs"
      :placeholder="placeholder || $t(i18n.placeholder)"
      :state="validateState"
      @input="setValue"
      v-on="$listeners"
    ></b-form-input>
    <slot name="button-append"></slot>
    <b-form-invalid-feedback
      v-if="i18n.validation"
      :id="'invalid-' + feedback_id"
    >
      {{ $t(i18n.validation, validations.params) }}
    </b-form-invalid-feedback>
    <b-form-invalid-feedback v-else :id="'invalid-' + feedback_id">
      {{ $t("VALIDATION.INVALID", { name: "" }) }}
    </b-form-invalid-feedback>
    <b-form-valid-feedback :id="'valid-' + feedback_id">
      {{ $t("VALIDATION.VALID") }}
    </b-form-valid-feedback>
  </b-input-group>
</template>

<script>
export default {
  name: "FormInput",
  inheritAttrs: false,
  props: {
    /**
     * name of the input
     */
    name: {
      type: String,
      default: "",
    },
    /**
     * form helper description
     */
    description: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    /**
     * All Translation i18n keys used
     */
    feedback_id: {
      type: String,
      default: "",
    },
    /**
     * All Translation i18n keys used
     */
    i18n: {
      type: Object,
      default: () => ({}),
    },
    /**
     * All validations rules and params
     */
    validations: {
      type: Object,
      default: () => ({}),
    },
    /**
     * Validate State validation
     */
    validateState: {
      type: Boolean,
      default: null,
    },
    /**
     * V-Model
     */
    value: {},
  },
  data() {
    return {};
  },
  components: {},
  mounted() {},
  computed: {},
  methods: {
    setValue(value) {
      //  trigger a mutation, or dispatch an action
      this.$emit("input", value);
    },
  },
};
</script>
